// extracted by mini-css-extract-plugin
module.exports = {"LoginButton":"_1vr1v","shopify":"_1HG7p","facebook":"_3HL25","google":"_3X2l4","IconWrap":"_2ajZR","Text":"UDinL"};